export const generalEnums = {
  TIMESHEET: 'Timesheet',
  EXPENSE: 'Expense',
  DATEFORMAT: 'YYYY-MM-DD',
  DATEFIRSTFORMAT: 'DD/MM/YYYY',
  DATEWITH_MMM: 'DD MMM YYYY',
  DATEWITHSTANDARD: 'Do MMMM YYYY',
  DATEANDMONTH: 'DD MMM',
  MONTHANDYEAR: 'MMMM YYYY',
  SIGNINPOLICY: 'B2C_1A_SUSI_WITH_TANDC',
  MAGICLINKPOLICY: 'B2C_1A_SIGNIN_ML',
  ONBOARDINGPOLICY: 'B2C_1A_SIGNUP_SIGNIN',
};

export const idTokenClaims = {
  IS_TNE_APPROVER: 'extension_IsTAndEApprover',
  IS_TNE_CONTRACTOR: 'extension_IsTAndEUser',
  IS_TIFO_USER: 'extension_IsTifoUser'
};

export const submissionEnum = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  BI_MONTHLY: 'semi-monthly',
  BI_WEEKLY: 'bi-weekly',
};

export const rateEnum = {
  DAILY: 'daily',
  HOURLY: 'hourly'
};

export const verticalPositions = {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom'
};

export const horiontalPositions = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const loginTypes = {
  SIGNIN: 'signin',
  SIGNUP: 'signup'
};

export const PAGE_TYPES = {
  UNSUBSCRIBE: 'unsubscribe',
  NOTIFICATION_SETTINGS: 'notification',
  JOBS: 'jobs'
};

export const TNE_SORT_BY = {
  PERIOD: 'By creation date',
  CHANGE: 'By change date'
};

export const ACCESS_TOKEN_NAME = 'AirswiftAccessToken';
